export default {
  "sMTPHost": "SMTP Host",
  "sMTPPort": "SMTP Port",
  "encryption": "Encryption",
  "username": "Username",
  "password": "Password",
  "aPIKey": "API Key",
  "sendingDomain": "Sending Domain",
  "region": "Region",
  "serverToken": "Server Token",
  "accessKeyID": "Access Key ID",
  "secretAccessKey": "Secret Access Key",
  "provider": "Provider",
  "templates": "Templates",
  "advanced": "Advanced",
  "log": "Log",
  "emailSettingsSaved": "Email settings saved",
  "yourChangesHaveBeenApplied": "Your changes have been applied.",
  "failedToSaveEmailSettings": "Failed to save email settings",
  "pleaseCheckTheFormForErrors": "Please check the form for errors.",
  "testEmailSent": "Test email sent",
  "testEmailFailed": "Test email failed",
  "leaveBlankToKeepTheCurrentValue": "Leave blank to keep the current value.",
  "configured": "Configured",
  "emailSettings": "Email Settings",
  "notConfigured": "Not configured",
  "configureYourEmailProviderAndCustomizeEmailTemplates": "Configure your email provider and customize email templates.",
  "emailSettingsTabs": "Email settings tabs",
  "loadingEmailSettings": "Loading email settings...",
  "emailProvider": "Email Provider",
  "chooseHowYourDashboardSendsEmails": "Choose how your dashboard sends emails",
  "selectYourEmailDeliveryService": "Select your email delivery service",
  "fromName": "From Name",
  "displayNameForOutgoingEmails": "Display name for outgoing emails",
  "fromAddress": "From Address",
  "senderEmailAddress": "Sender email address",
  "sendsATestEmailToTheAdminAddress": "Sends a test email to the admin address.",
  "sending": "Sending...",
  "sendTest": "Send Test",
  "reset": "Reset",
  "saving": "Saving...",
  "saveChanges": "Save Changes",
  "renderingSettingsSaved": "Rendering settings saved",
  "failedToSave": "Failed to save",
  "emailLogoUploaded": "Email logo uploaded",
  "uploadFailed": "Upload failed",
  "pleaseTryAgain": "Please try again.",
  "emailLogoRemoved": "Email logo removed",
  "resetFailed": "Reset failed",
  "loadingAdvancedSettings": "Loading advanced settings...",
  "publicDashboardURLNotConfigured": "Public Dashboard URL not configured",
  "emailImagesLogosBrandingMayNotDisplayForRecipients": "Email images (logos, branding) may not display for recipients. Set the \"Web Root\" in General Settings to your public dashboard URL (e.g., https://box.example.com).",
  "goToGeneralSettings": "Go to General Settings",
  "emailBranding": "Email Branding",
  "uploadLogosThatAppearInOutgoingEmailHeadersWhen": "Upload logos that appear in outgoing email headers. When no custom email logo is set, the site logo is used.",
  "previewsShowTheSiteLogosUploadCustomEmailLogos": "Previews show the site logos. Upload custom email logos to override.",
  "emailRendering": "Email Rendering",
  "controlHowOutgoingEmailsAppearToRecipients": "Control how outgoing emails appear to recipients.",
  "showLogoInEmails": "Show logo in emails",
  "displayTheUploadedEmailLogoOrSiteLogoIn": "Display the uploaded email logo (or site logo) in the header of outgoing emails.",
  "showHeaderText": "Show header text",
  "displayHeaderTextOrSiteNameAboveTheEmail": "Display header text (or site name) above the email body. When disabled, only the logo (if enabled) appears in the header.",
  "headerText": "Header Text",
  "customTextDisplayedInTheEmailHeaderLeaveEmpty": "Custom text displayed in the email header. Leave empty to use the site name.",
  "showFooterText": "Show footer text",
  "displayFooterTextBelowTheEmailBodyWhenDisabled": "Display footer text below the email body. When disabled, only the timestamp remains in the footer.",
  "footerText": "Footer Text",
  "sentByQuickBoxPro": "Sent by QuickBox Pro",
  "customFooterTextLeaveEmptyForTheDefaultSent": "Custom footer text. Leave empty for the default 'Sent by {site name}'.",
  "all": "All",
  "security": "Security",
  "system": "System",
  "account": "Account",
  "notification": "Notification",
  "disabled": "Disabled",
  "failedToLoadTemplate": "Failed to load template",
  "templateSaved": "Template saved",
  "failedToSaveTemplate": "Failed to save template",
  "templateResetToDefault": "Template reset to default",
  "failedToResetTemplate": "Failed to reset template",
  "failedToRenderPreview": "Failed to render preview",
  "emailTemplates": "Email Templates",
  "loading": "Loading...",
  "searchTemplates": "Search templates...",
  "noTemplatesFound": "No templates found",
  "noMatches": "No matches",
  "selectATemplateToEdit": "Select a template to edit",
  "chooseAnEntryFromTheListOnTheLeft": "Choose an entry from the list on the left",
  "customized": "Customized",
  "preview": "Preview",
  "previewTemplate": "Preview template",
  "resetToDefault": "Reset to default",
  "resetTemplateToDefault": "Reset template to default",
  "default": "Default",
  "enabled": "Enabled",
  "whenDisabledThisEmailWillNotBeSent": "When disabled, this email will not be sent.",
  "subject": "Subject",
  "emailSubjectLine": "Email subject line",
  "hTMLBody": "HTML Body",
  "plainTextBody": "Plain Text Body",
  "plainTextFallback": "Plain text fallback...",
  "availableVariables": "Available Variables",
  "rendering": "Rendering...",
  "refreshPreview": "Refresh Preview",
  "generatePreview": "Generate Preview",
  "plainText": "Plain Text",
  "emailPreview": "Email Preview",
  "unsavedChanges": "Unsaved changes",
  "discard": "Discard",
  "save": "Save",
  "recipient": "Recipient",
  "status": "Status",
  "sent": "Sent",
  "failed": "Failed",
  "date": "Date",
  "selectAll": "Select all",
  "failedToLoadEmailLog": "Failed to load email log.",
  "logEntryDeleted": "Log entry deleted",
  "failedToDeleteLogEntry": "Failed to delete log entry",
  "failedToDeleteLogEntries": "Failed to delete log entries",
  "failedToClearLog": "Failed to clear log",
  "clearAll": "Clear All",
  "refresh": "Refresh",
  "totalSent": "Total Sent",
  "totalFailed": "Total Failed",
  "last24Hours": "Last 24 Hours",
  "deleteSelected": "Delete Selected",
  "clearSelection": "Clear Selection",
  "thisActionCannotBeUndone": "This action cannot be undone.",
  "deleting": "Deleting...",
  "cancel": "Cancel",
  "emailLog": "Email Log",
  "historyOfEmailDeliveryAttempts": "History of email delivery attempts.",
  "searchEmails": "Search emails...",
  "noEmailLogEntriesFound": "No email log entries found.",
  "delete": "Delete",
  "noneDisabled": "None (Disabled)",
  "none": "None",
  "uS": "US",
  "eU": "EU",
  "uSEastNVirginia": "US East (N. Virginia)",
  "uSEastOhio": "US East (Ohio)",
  "uSWestNCalifornia": "US West (N. California)",
  "uSWestOregon": "US West (Oregon)",
  "eUIreland": "EU (Ireland)",
  "eULondon": "EU (London)",
  "eUFrankfurt": "EU (Frankfurt)",
  "asiaPacificSingapore": "Asia Pacific (Singapore)",
  "asiaPacificSydney": "Asia Pacific (Sydney)",
  "asiaPacificTokyo": "Asia Pacific (Tokyo)",
  "canadaCentral": "Canada (Central)",
  "southAmericaSaoPaulo": "South America (Sao Paulo)",
  "youDonTHavePermissionToViewEmailSettings": "You don't have permission to view email settings.",
  "failedToLoadEmailSettings": "Failed to load email settings",
  "failedToUpdateEmailSettings": "Failed to update email settings",
  "testEmailSentSuccessfully": "Test email sent successfully",
  "failedToSendTestEmail": "Failed to send test email",
  "insufficientPermissions": "Insufficient permissions",
  "failedToLoadSettings": "Failed to load settings",
  "failedToLoadEmailTemplates": "Failed to load email templates",
  "failedToFetchTemplate": "Failed to fetch template",
  "failedToUpdateTemplate": "Failed to update template",
  "providerConfiguration": "{{provider}} Configuration",
  "configureProviderConnection": "Configure your {{provider}} connection",
  "templateCount_one": "{{formattedCount}} template",
  "templateCount_other": "{{formattedCount}} templates",
  "selectedCount_one": "{{formattedCount}} selected",
  "selectedCount_other": "{{formattedCount}} selected",
  "deletedEntries_one": "Deleted {{formattedCount}} log entry",
  "deletedEntries_other": "Deleted {{formattedCount}} log entries",
  "clearedEntries_one": "Cleared {{formattedCount}} log entry",
  "clearedEntries_other": "Cleared {{formattedCount}} log entries",
  "clearedAllEntries": "Cleared all log entries",
  "selectEntry": "Select entry {{id}}",
  "deleteAllEntries_one": "Are you sure you want to delete {{formattedCount}} email log entry?",
  "deleteAllEntries_other": "Are you sure you want to delete all {{formattedCount}} email log entries?",
  "fullLogoExplanation": "The {{logo}} is displayed in the email header above the site name. For best results, use a transparent PNG or SVG with a light-colored design (emails use a dark background).",
  "iconLogoExplanation": "The {{logo}} is reserved for compact email contexts and future notification integrations.",
  "fullLogo": "full logo",
  "iconLogo": "icon logo",
  "variableHelp": "Supports {{example}} placeholders",
  "htmlPlaceholder": "{{openTag}}HTML email content...{{closeTag}}",
  "deleteAll": "Delete All",
  "sendTestAfterSaveHelp": "Saves your settings, then sends a test email to the admin address.",
  "slugValue": "Slug: {{slug}}",
  "email.forbidden": "Insufficient permissions",
  "email.settings.fetchFailed": "Failed to fetch email settings",
  "email.settings.updateFailed": "Failed to update email settings",
  "email.test.adminEmailMissing": "No admin email configured. Set it in General Settings first.",
  "email.test.sendFailed": "Failed to send test email",
  "email.advanced.fetchFailed": "Failed to fetch email advanced settings",
  "email.advanced.updateFailed": "Failed to update email advanced settings",
  "email.test.sent": "Test email sent to {{recipient}}",
  "email.templates.listFailed": "Failed to list email templates",
  "email.templates.notFound": "Template not found",
  "email.templates.fetchFailed": "Failed to fetch email template",
  "email.templates.updateFailed": "Failed to update email template",
  "email.templates.notSystem": "Template not found or is not a system template",
  "email.templates.reset": "Template reset to default",
  "email.templates.resetFailed": "Failed to reset email template",
  "email.templates.previewFailed": "Failed to render template preview",
  "email.log.invalidQuery": "Invalid query parameters",
  "email.log.listFailed": "Failed to list email logs",
  "email.log.statsFailed": "Failed to fetch email log stats",
  "email.log.invalidId": "Invalid email log ID",
  "email.log.deleteFailed": "Failed to delete email log entry",
  "email.log.invalidBody": "Invalid request body",
  "email.log.bulkDeleteFailed": "Failed to bulk-delete email log entries",
  "email.log.confirmRequired": "Body must include { confirm: true }",
  "email.log.clearFailed": "Failed to clear email logs",
  "email.dispatch.providerMissing": "No email provider configured",
  "email.dispatch.fromAddressMissing": "No from address configured",
  "email.dispatch.smtpHostMissing": "SMTP host is not configured",
  "email.dispatch.mailgunRequired": "Mailgun API key and domain are required",
  "email.dispatch.sendgridRequired": "SendGrid API key is required",
  "email.dispatch.postmarkRequired": "Postmark server token is required",
  "email.dispatch.sparkpostRequired": "SparkPost API key is required",
  "email.dispatch.sesRequired": "AWS SES access key and secret are required",
  "email.dispatch.unknownProvider": "Unknown email provider: {{provider}}",
  "email.dispatch.unknownError": "Unknown email error",
  "email.dispatch.mailgunError": "Mailgun error ({{status}}): {{message}}",
  "email.dispatch.sendgridError": "SendGrid error ({{status}}): {{message}}",
  "email.dispatch.postmarkError": "Postmark error ({{status}}): {{message}}",
  "email.dispatch.sparkpostError": "SparkPost error ({{status}}): {{message}}",
  "email.dispatch.sesError": "AWS SES error ({{status}}): {{message}}",
  "email.template.security-new-login.name": "New Login Detected",
  "email.template.security-new-login.description": "Sent when a new login is detected from an unrecognized device or location.",
  "email.template.security-password-changed.name": "Password Changed",
  "email.template.security-password-changed.description": "Confirmation sent when a user changes their password.",
  "email.template.system-disk-usage.name": "Disk Usage Alert",
  "email.template.system-disk-usage.description": "Sent when disk usage exceeds a configured threshold.",
  "email.template.app-offline.name": "Application Offline",
  "email.template.app-offline.description": "Sent when a monitored application goes offline.",
  "email.template.account-welcome.name": "Welcome Email",
  "email.template.account-welcome.description": "Sent to new users after successful registration when welcome email is enabled.",
  "email.template.account-activation.name": "Account Activation",
  "email.template.account-activation.description": "Sent when email verification is required for new registrations (activation mode 2).",
  "email.template.system-monitor-alert.name": "System Monitor Alert",
  "email.template.system-monitor-alert.description": "Sent when a system monitor rule triggers (e.g. high CPU, memory, swap, disk, or load).",
  "email.template.vpn-routing-failback.name": "VPN Routing Failback",
  "email.template.vpn-routing-failback.description": "Sent when a VPN tunnel becomes stale and app routing is automatically disabled to restore connectivity.",
  "email.template.vpn-routing-kill-switch.name": "VPN Kill Switch Triggered",
  "email.template.vpn-routing-kill-switch.description": "Sent when the VPN kill switch triggers and fully stops a routed service to prevent traffic leaks.",
  "email.template.password-reset.name": "Password Reset",
  "email.template.password-reset.description": "Sent when a user requests a password reset link.",
  "email.template.test-email.name": "Test Email",
  "email.template.test-email.description": "Used to verify email delivery configuration.",
  "email.template.vpn-routing-recovery-success.name": "VPN Auto-Recovery Success",
  "email.template.vpn-routing-recovery-success.description": "Sent when auto-recovery successfully restores a routed service after a kill switch event.",
  "email.template.vpn-routing-recovery-exhausted.name": "VPN Auto-Recovery Exhausted",
  "email.template.vpn-routing-recovery-exhausted.description": "Sent when auto-recovery fails after all retry attempts and requires manual intervention.",
  "email.template.vpn-config-staleness-warning.name": "VPN Config Aging",
  "email.template.vpn-config-staleness-warning.description": "Sent when a stashed VPN config crosses into the aging window and should be refreshed soon.",
  "email.template.vpn-config-dead.name": "VPN Config Dead",
  "email.template.vpn-config-dead.description": "Sent when a stashed VPN config is confirmed dead (server decommissioned) and auto-handled.",
  "email.template.vpn-config-stale.name": "VPN Config Stale",
  "email.template.vpn-config-stale.description": "Sent when a stashed NordVPN config is classified stale (server decommissioned) — fires on classification, independent of auto-cleanup.",
  "email.template.security-mfa-changed.name": "MFA Changed",
  "email.template.security-mfa-changed.description": "Sent when two-factor authentication or a passkey is enabled, disabled, added, or removed.",
  "email.template.app-online.name": "Application Online",
  "email.template.app-online.description": "Sent when a monitored application service comes back online.",
  "email.template.app-update-available.name": "Application Update Available",
  "email.template.app-update-available.description": "Sent when a managed application has a new version available.",
  "email.template.app-updates-available.name": "Application Updates Available (Aggregated)",
  "email.template.app-updates-available.description": "Sent when multiple managed applications have new versions available.",
  "email.template.qb-update-available.name": "QuickBox Update Available",
  "email.template.qb-update-available.description": "Sent when a new QuickBox CLI/server core version is available (v3 platform update, not the dashboard).",
  "email.template.dashboard-update-available.name": "Dashboard Update Available",
  "email.template.dashboard-update-available.description": "Sent when a new v4 web dashboard version is available (separate from the QuickBox CLI/server core).",
  "email.template.signal-update-available.name": "signal-cli Update Available",
  "email.template.signal-update-available.description": "Sent to admins when a new version of the signal-cli binary is available on GitHub.",
  "email.template.news-announcement.name": "QuickBox News Announcement",
  "email.template.news-announcement.description": "Sent to admins when a new QuickBox news announcement is published.",
  "email.template.news-announcement-updated.name": "QuickBox News Announcement Updated",
  "email.template.news-announcement-updated.description": "Sent to admins when an existing QuickBox news announcement's content changes.",
  "email.template.app-updated-success.name": "Application Updated Successfully",
  "email.template.app-updated-success.description": "Sent when a managed application update completes successfully.",
  "email.template.app-update-failed.name": "Application Update Failed",
  "email.template.app-update-failed.description": "Sent when a managed application update fails.",
  "email.template.job-completed.name": "Job Completed",
  "email.template.job-completed.description": "Sent when a package install/remove/update job completes successfully.",
  "email.template.job-failed.name": "Job Failed",
  "email.template.job-failed.description": "Sent when a package install/remove/update job fails.",
  "email.template.media-share-link.name": "Media Share Link",
  "email.template.media-share-link.description": "Sent when a shared media file link is emailed to a recipient.",
  "email.template.security-attack-spike.name": "Attack Spike Detected",
  "email.template.security-attack-spike.description": "Sent to admins when a surge of bans is detected — multiple distinct IPs banned within a short window, indicating a possible coordinated attack.",
  "email.validation.settings.smtp.port.range": "Port must be between 1 and 65535",
  "email.validation.settings.fromName.max": "From name must be 100 characters or less",
  "email.validation.settings.smtp.host.max": "SMTP host must be 255 characters or less",
  "email.validation.settings.smtp.username.max": "Username must be 255 characters or less",
  "email.validation.settings.smtp.password.max": "Password must be 255 characters or less",
  "email.validation.settings.mailgun.apiKey.max": "API key must be 255 characters or less",
  "email.validation.settings.mailgun.domain.max": "Domain must be 255 characters or less",
  "email.validation.settings.sendgrid.apiKey.max": "API key must be 255 characters or less",
  "email.validation.settings.postmark.serverToken.max": "Server token must be 255 characters or less",
  "email.validation.settings.sparkpost.apiKey.max": "API key must be 255 characters or less",
  "email.validation.settings.ses.accessKeyId.max": "Access key ID must be 255 characters or less",
  "email.validation.settings.ses.secretAccessKey.max": "Secret access key must be 255 characters or less",
  "email.validation.settings.ses.region.max": "Region must be 64 characters or less",
  "email.validation.template.subject.min": "Subject is required",
  "email.validation.template.subject.max": "Subject too long",
  "email.validation.template.bodyHtml.max": "HTML body too large",
  "email.validation.template.bodyText.max": "Text body too large",
  "email.validation.advanced.headerText.max": "Header text must be 200 characters or less",
  "email.validation.advanced.footerText.max": "Footer text must be 500 characters or less",
  "email.validation.settings.fromAddress.email": "Must be a valid email address",
  "email.validation.settings.smtp.port.regex": "Port must be a number",
  "email.validation.required": "Required",
  "email.validation.invalidType": "Expected {{expected}}",
  "email.validation.invalidChoice": "Choose one of: {{options}}",
  "email.validation.invalidInput": "Invalid input",
  "email.validation.logBulk.min": "At least one email log ID is required",
  "email.validation.logBulk.max": "At most 500 email log IDs are allowed",
  "email.validation.logBulk.positive": "Email log IDs must be greater than 0",
  "email.validation.logBulk.integer": "Email log IDs must be integers"
} as const;
